import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const StairsIcon = ({ width = 60, height = 60, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_6828_51861)">
                <path
                    d="M56.6504 13.8496V16.7949H46.9043V27.916H33.2021V39.5596H19.0947V50.5791H6.00781V57.8857H3.34961V47.6504H16.1494V36.623H30.2568V24.9873H30.3496V24.9707H43.9678V13.8496H56.6504Z"
                    fill={fill}
                    stroke={fill}
                    strokeWidth="0.7"       
                />
            </g>
            <defs>
                <clipPath id="clip0_6828_51861">
                    <rect width="54" height="44.7356" fill={fill} transform="translate(3 13.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
